// import './directives/index'

require.config({
    map: {
        "*": {
            conditioner: "vendor/conditionerjs/conditioner",
            "conditioner/utils": "vendor/conditionerjs/utils",
            mustache: "vendor/janl/mustache",
            "ui/toggle": "vendor/eweerstra/toggle",
            easing: "vendor/danro/easing",
            picturefill: "vendor/polyfills/picturefill",
            objectassign: "vendor/polyfills/ObjectAssign"
        }
    }
});

let polyfills = [];

if (!("Promise" in window)) {
    polyfills.push("vendor/polyfills/Promise");
}

if (!("HTMLPictureElement" in window)) {
    polyfills.push("vendor/polyfills/picturefill");
}

if (!("assign" in Object)) {
    polyfills.push("vendor/polyfills/ObjectAssign");
}

/**
 * Load polyfills & start Conditioner.js
 */

require(["conditioner", "directives/index"].concat(polyfills), function(conditioner) {
    conditioner.init();
});
